import styled from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { WHITE, GRADIENT } from 'ai-components-ui-library/styles/colors';

/** CSS taken from here - https://codyhouse.co/nuggets/css-gradient-borders#alternative-approach.
 * This is a way to create gradient borders in CSS while preseving border-radius. */
import { jsx as _jsx } from "react/jsx-runtime";
const StyledBreezeTile = styled(UITile).withConfig({
  displayName: "BreezeTile__StyledBreezeTile",
  componentId: "sc-1ck33l7-0"
})(["width:100%;padding:1px;border:1px solid transparent;display:inline-block;border-radius:3px;background:linear-gradient(", ",", ") padding-box,", " border-box;"], WHITE, WHITE, GRADIENT['MEDIUM']);
const BreezeTile = ({
  children
}) => {
  return /*#__PURE__*/_jsx(StyledBreezeTile, {
    children: /*#__PURE__*/_jsx(UITileSection, {
      className: "p-top-4 p-x-5 p-bottom-5",
      children: children
    })
  });
};
export default BreezeTile;